const canUseDOM = () => {
    if (typeof window === 'undefined' || !window.document) {
        return false;
    }
    return true;
};

export const toggleWidget = () => {
    if (canUseDOM() && (window as any).zE) {
        const stateWidget = (window as any).zE('webWidget:get', 'display');
        if (stateWidget === 'hidden' || stateWidget === 'launcher') {
            (window as any).zE('webWidget', 'show');
            (window as any).zE('webWidget', 'open');
        } else {
            //(window as any).zE('webWidget', 'hide');  //chiude e fa sparire l'icona (per la gestione senza icona con il search nella toolbar)
            (window as any).zE('webWidget', 'close'); // chiude il menu e lo rende icona
        }
    } else {
        console.warn('Zendesk is not initialized yet');
    }
};

export const setWidgetFalse = () => {
    if (canUseDOM() && (window as any).zE) {
        (window as any).zE('webWidget', 'close');
    } else {
        console.warn('Zendesk is not initialized yet');
    }
};
